import { AppPages } from '@app/app.pages';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IsAuthenticatedDirective } from '@app/directives/is-authenticated/is-authenticated.directive';
import { IsNotAuthenticatedDirective } from '@app/directives/is-not-authenticated/is-not-authenticated.directive';
import { LogoutDirective } from '@app/directives/logout/logout.directive';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { model } from '@angular/core';
@Component({
    imports: [
        AsyncPipe,
        IsAuthenticatedDirective,
        IsNotAuthenticatedDirective,
        LogoutDirective,
        RouterLink,
        TranslateModule
    ],
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
    public appPages = AppPages;
    public isDrawerOpen = model<boolean>(false); // Initialize with a default value

    public onClick(value: boolean): void {
        this.isDrawerOpen.set(value);
    }
}
